import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import axios from "axios";

const API_URL = process.env.REACT_APP_AUTH_URL;

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [agreePolicy, setAgreePolicy] = useState(true); // ✅ já marcado
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    if (!agreePolicy) {
      setErrorMessage("Você deve concordar com a Política de Privacidade para continuar.");
      setLoading(false);
      return;
    }

    try {
      await axios.post(`${API_URL}/register`, {
        username: name,
        email,
        password,
      });

      setSuccessMessage("Conta criada com sucesso!");
      setLoading(false);

      setName("");
      setEmail("");
      setPassword("");

      setTimeout(() => {
        navigate("/auth/login");
      }, 1000);
    } catch (error) {
      setErrorMessage("Falha ao criar conta. Tente novamente.");
      setLoading(false);
    }
  };

  const handleLogin = () => {
    navigate("/auth/login");
  };

  return (
    <>
      <Col lg="6" md="8">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Cadastre-se com suas credenciais</small>
            </div>
            {errorMessage && (
              <p className="text-danger text-center">{errorMessage}</p>
            )}
            {successMessage && (
              <p className="text-success text-center">{successMessage}</p>
            )}
            <Form role="form" onSubmit={handleRegister}>
              <FormGroup>
                <InputGroup className="input-group-alternative mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-hat-3" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Nome"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Senha"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </InputGroup>
              </FormGroup>
              <Row className="my-4">
                <Col xs="12">
                  <div className="custom-control custom-control-alternative custom-checkbox">
                    <input
                      className="custom-control-input"
                      id="customCheckRegister"
                      type="checkbox"
                      checked={agreePolicy}
                      onChange={(e) => setAgreePolicy(e.target.checked)}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customCheckRegister"
                    >
                      <span className="text-muted">
                        Eu concordo com a{" "}
                        <a
                          href="/auth/privacypolicy"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-info"
                        >
                          Política de Privacidade
                        </a>
                      </span>
                    </label>
                  </div>
                </Col>
              </Row>
              <div className="text-center">
                {!loading ? (
                  <Button className="mt-4" color="primary" type="submit">
                    Criar conta
                  </Button>
                ) : (
                  <Spinner className="mt-4" color="primary" />
                )}
              </div>
            </Form>
          </CardBody>
        </Card>
        <Row className="mt-3">
          <Col className="text-right" xs="12">
            <a
              className="text-light"
              href="#pablo"
              onClick={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              <small>Fazer Login</small>
            </a>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default Register;
